import {
    ExpressCheckoutConditionsActionType,
    SaveExpressCheckoutConditionsAction,
} from '../actions/expressCheckout';
import { ExpressCheckout } from '../state/expressCheckout';

export const expressCheckoutReducer = (
    state: ExpressCheckout = {
        expressCheckoutConditions: null,
    },
    action: SaveExpressCheckoutConditionsAction,
): ExpressCheckout => {
    switch (action.type) {
        case ExpressCheckoutConditionsActionType.saveExpressCheckoutConditions:
            return {
                ...state,
                expressCheckoutConditions: {
                    ...action.payload,
                },
            };
        default:
            return state;
    }
};
